import { render, staticRenderFns } from "./InternationalConsultation.vue?vue&type=template&id=661d19e9&scoped=true&"
import script from "./InternationalConsultation.vue?vue&type=script&lang=js&"
export * from "./InternationalConsultation.vue?vue&type=script&lang=js&"
import style0 from "./InternationalConsultation.vue?vue&type=style&index=0&id=661d19e9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "661d19e9",
  null
  
)

export default component.exports